import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

function Block({ block }) {
  if (block.type === "ul") {
    return (
      <ul className="legal-list">
        {block.items.map((it, i) => <li key={i}>{it}</li>)}
      </ul>
    );
  }
  return <p>{block.text}</p>;
}

export default function Legal({ doc }) {
  if (!doc) return null;
  return (
    <>
      <Nav />
      <main>
        <header id="top" className="hero hero--compact">
          <div className="wrap hero-inner">
            <span className="eyebrow">{doc.eyebrow}</span>
            <h1 className="display-1">{doc.title}</h1>
            <p className="legal-updated">Last updated: {doc.updated}</p>
          </div>
        </header>

        <section className="section">
          <div className="wrap legal-body">
            {doc.intro && <p className="legal-intro">{doc.intro}</p>}
            {doc.sections.map((s, i) => (
              <div key={i} className="legal-section">
                <h2 className="legal-heading">{s.heading}</h2>
                {s.blocks.map((b, j) => <Block key={j} block={b} />)}
              </div>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
